import React from 'react'
import "./LandingPage.css"
import { LogoSmartQuest, LeftVector, RightVector } from '../../assets'
import { Button } from '@chakra-ui/react';
import { useTypewriter, Cursor } from 'react-simple-typewriter';
import { Link } from 'react-router-dom';


const LandingPage = () => {
  const [typeEffect] = useTypewriter({
    words: ["Le futur de la science commence aujourd'hui"], 
    loop: true,                                            
    typeSpeed: 50,                                         
    delaySpeed: 2000                                       
  });
  return (
  <div className="visitor-landing-page">
      <div>
      <img src={LeftVector} alt="left" className="vibrate-1 leftImageStyle"  />
      
      <img src={RightVector} alt="Right" className="vibrate-2 rightImageStyle"  />
      </div>

      <div className="landing-content">
        <img src={LogoSmartQuest} alt="SmartQuest Logo" className="logo" />
        <h1 className="landing-main-title">
          {typeEffect}
          <Cursor cursorStyle="|" />
        </h1>
        
        <p className="description">
          Une plateforme complète pour tous vos besoins de recherche scientifique,
          assurant la sûreté et la rapidité, la fiabilité et la lisibilité des données,
          et la sécurité et la facilité d'utilisation.
        </p>
        
        <Button variant="outline" borderRadius={50} className="start-button">
          <Link to="/registration" style={{ color: '#262626', textDecoration: 'none' }}>
            Commencer maintenant avec <span className="smart">Smart</span>
            <span className="quest">Quest</span>
          </Link>
        </Button>

        {/* Login section */}
        <div className="login-section">
          <p>J'ai déjà un compte</p>
          <Link to="/login" className="login-link"> 
              se connecter
          </Link>
        </div>
      </div>
    </div>
  );
}

export default LandingPage